<template>
  <b-form-group
    :label="label"
    :label-size="size"
  >
    <ValidationProvider
      v-slot="validationContext"
      :name="name"
      :rules="validate"
      :mode="validationMode"
    >
      <!-- <b-form-input
        v-model="_value"
        :type="type"
        :name="name"
        :placeholder="placeholder"
        :autocomplete="autocomplete"
        :state="getValidationState(validationContext)"
        :size="size"
        :step="step"
        :min="min"
        :max="max"
      >
      </b-form-input> -->
      <!--
      <b-form-datepicker id="example-datepicker" v-model="_value" class="mb-2">
      </b-form-datepicker>
      -->
      <DatePicker v-model="_value" :model-config="modelConfig"  color="yellow" is-expanded :key="datePickerKey"/>
      <b-form-invalid-feedback
        v-if="showErrorMessage"
        :state="validationContext.errors.length === 0"
      >
        {{ validationContext.errors.join('. ') }}
      </b-form-invalid-feedback>
<!--<small v-if="!validate">Opcional</small>-->
    </ValidationProvider>
  </b-form-group>
</template>

<script>
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
  export default {
    name: 'InputTextComponent',
    components: {
      Calendar,
      DatePicker
    },
    data(){
      return{
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD',
      },
      datePickerKey:0
      }
    },
    mounted(){
      if(!this.value){
        this.value = this.assessmentDate
        // this.datePickerKey++
      }
    },
    props: {
      assessmentDate:{
        type: String,
        required: true
      },
      name: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        required: false,
        default: ''
      },
      placeholder: {
        type: String,
        required: false,
        default: ''
      },
      validate: {
        type: [String, Object],
        required: false,
        default: ''
      },
      value: {
        type: [String, Number],
        required: false,
        default: null,
      },
      validationMode: {
        type: String,
        required: false,
        default: 'aggressive' // passive, lazy, eager (https://vee-validate.logaretm.com/v3/guide/interaction-and-ux.html#interaction-modes)
      },
      type: {
        type: String,
        required: false,
        default: 'text',
      },
      step: {
        type: Number,
        required: false,
        default: null,
      },
      min: {
        type: Number,
        required: false,
        default: null,
      },
      max: {
        type: Number,
        required: false,
        default: null,
      },
      size: {
        type: String,
        required: false,
        default: ''
      },
      autocomplete: {
        type: String,
        required: false,
        default: ''
      },
      showErrorMessage: {
        type: Boolean,
        required: false,
        // eslint-disable-next-line vue/no-boolean-default
        default: true,
      }
    },
    computed: {
      _value: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('update:value', value.trim())
          this.$emit('input', value.trim())
          this.datePickerKey++
        }
      }
    },
    methods: {
      getValidationState({ validated, valid = null}) {
        return validated ? valid : null
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>